
import React from "react";

type Props = {
  videoId: string;
  startSec: number;
  className?: string;
};

/**
 * YouTubePlayer - Iframe Embed Officiel
 * Pas de tracking audio direct pour conformité légale.
 */
export const YouTubePlayer: React.FC<Props> = ({ videoId, startSec, className = "" }) => {
  const src = `https://www.youtube.com/embed/${videoId}?start=${Math.floor(
    startSec
  )}&autoplay=0&controls=1&modestbranding=1&rel=0`;

  return (
    <div className={`youtube-wrapper relative w-full aspect-video rounded-3xl overflow-hidden border border-white/10 bg-black shadow-2xl ${className}`}>
      <iframe
        src={src}
        allow="autoplay; encrypted-media"
        allowFullScreen
        frameBorder={0}
        className="absolute inset-0 w-full h-full"
      />
    </div>
  );
};
